import { Button } from '@accure/ui';

import type { Workstream } from '@/project-management/entities/workstream';
import { useAddTaskModal } from '@/project-management/modals/add-task';

export type WorkstreamEmptyTasksProps = {
  workstream: Pick<Workstream, 'id'>;
};

export function WorkstreamEmptyTasks({
  workstream,
}: WorkstreamEmptyTasksProps) {
  const addTask = useAddTaskModal();

  return (
    <div className="flex flex-col items-center gap-2 p-6">
      <p className="text-center text-gray-600">
        No tasks in this workstream yet.
      </p>
      <Button
        variant="link"
        size="sm"
        onClick={() =>
          addTask({ formType: 'create', workstreamId: workstream.id })
        }
      >
        add a task
      </Button>
    </div>
  );
}
